import logging from 'node-logging-js';
import jsb from 'node-jsb';
import Swiper from 'swiper';

/* Documentation http://idangero.us/swiper/ */
class Clients {
    constructor(element, options) {
        logging.applyLogging(this, 'Clients');
        this.logDebug('options:', options);
        this.element = element;
        this.slideNumba = this.element.querySelector('.js-number');
        this.slideWrap = this.element.querySelector('.js-wrap');

        this.initialize();
    }

    initialize() {
        this.Clients = new Swiper(this.element, {
            slidesPerView: 5,
            spaceBetween: 60,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                // when window width is >= 320px
                600: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                900: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 60
                },
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 60
                }
            },
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			}
        });
    }
}

jsb.registerHandler('Clients', Clients);
export default Clients;
